import { styled, Box } from '@mui/material';

export const BoxWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.primary.main
}));

export const OfferNumberWrapper = styled('span')(({ theme }) => ({
  color: theme.palette.warning.main
}));
